// @flow
import { ALL_INCLUSIVE_PUSH } from 'Client/cms/toolkit/constants';
import { AllInclusivePushLine } from 'Components/lines/all-inclusive-push-line/AllInclusivePushLine.jsx';

export const allInclusivePushDescriptor = {
  name: ALL_INCLUSIVE_PUSH,
  component: AllInclusivePushLine,
};
